import {ChangeDetectionStrategy, Component} from '@angular/core';
import {NbComponentType, NbWindowService} from '@nebular/theme';
import {CatalogPickerComponent} from '../catalog-picker/catalog-picker.component';
import {DamChooseCatalogModalComponent} from '../dam-choose-catalog-modal/dam-choose-catalog-modal.component';
import {DamCatalogService} from '../../../cabinet/dam/services/dam-catalog.service'

@Component({
  templateUrl: './../catalog-picker/catalog-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamCatalogPickerComponent extends CatalogPickerComponent {
  modalComponent: NbComponentType = DamChooseCatalogModalComponent;

  constructor(
    protected readonly windowService: NbWindowService,
    protected readonly catalogService: DamCatalogService,
  ) {
    super(windowService, catalogService);
  }

}
